'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleton = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _RUMUtil = require('../utils/RUMUtil');

var _RUMUtil2 = _interopRequireDefault(_RUMUtil);

var _EventPumpAbstract2 = require('./EventPumpAbstract');

var _EventPumpAbstract3 = _interopRequireDefault(_EventPumpAbstract2);

var _WSEvent = require('./WSEvent');

var _WSEvent2 = _interopRequireDefault(_WSEvent);

var _VideoManager = require('../video/VideoManager');

var _VideoManager2 = _interopRequireDefault(_VideoManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IDLE = 'IDLE';
var HTTP = 'HTTP';
var WS = 'WS';

// exporting this so users can do some validating of their own
var singleton = exports.singleton = Symbol.for('instance');
var singletonEnforcer = Symbol.for('enforcing');

var noop = function noop() {};

var EventPumpProducer = function (_EventPumpAbstract) {
  _inherits(EventPumpProducer, _EventPumpAbstract);

  function EventPumpProducer(enforcer) {
    _classCallCheck(this, EventPumpProducer);

    if (enforcer !== singletonEnforcer) {
      throw new Error('[EventPumpProducer] Cannot construct a singleton');
    }

    var _this = _possibleConstructorReturn(this, (EventPumpProducer.__proto__ || Object.getPrototypeOf(EventPumpProducer)).call(this, { isProducer: true, pollingInterval: 3000 }));

    _this.wsErrorHandler = function (eventData) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // if we failed to send an event via websocket, attempt a POST?
      if (!(0, _isUndefined2.default)(eventData)) {}
      // TODO don't deal with async stuff just yet
      // we can improve the durability of this in future Jira tickets


      // Currently, whenever we see any error in a Websocket, we will failover to http polling.
      // This keeps things simple for now.  We can always make this more sophisticated in the future.
      // componentEventHost will be null if the control room was shut down legitimately
      if (_this.validControlRoomShutdown === false) {
        var logData = {
          event: _extends({}, eventData),
          message: '[EventPumpProducer] failing to HTTP polling',
          additionalInfo: _extends({}, args)
        };
        _RUMUtil2.default.addError(logData);
        _this.failoverToHttp(_this.accountId, _this.eventId, _this.componentEventHost, _this.wsComponentEventHost);
      } else {
        console.log('[EventPumpProducer] control room is shutting down, not failing over to post/poll');
      }
    };

    _this.startEventPump = function (accountId, eventId, componentEventHost, wsComponentEventHost) {
      console.log('[EventPumpProducer] Starting event pump...');

      // since we are in a singleton, need to reset this variable when we start the event pump
      _this.validControlRoomShutdown = false;

      if (!_this.areValidParams(accountId, eventId, componentEventHost)) {
        throw new Error('\n        Parameters not valid\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');
      }

      _this.accountId = accountId;
      _this.eventId = eventId;
      _this.componentEventHost = componentEventHost;
      _this.wsComponentEventHost = wsComponentEventHost;

      // attempt to connect a websocket for the control room event pump
      var wsSuccess = _this.wsManager.initiate(accountId, eventId, wsComponentEventHost);
      if (wsSuccess) {
        // pumpStatus is used by the super class when determining which manager to send events to
        _this.pumpStatus = WS;
      } else {
        _this.failoverToHttp(accountId, eventId, componentEventHost, wsComponentEventHost);
      }
    };

    _this.wsManager = new _WSEvent2.default(_this.dataHandler, _this.wsErrorHandler);

    _this.videoManager = new _VideoManager2.default(noop, function (err) {
      console.warn('error happened in video manager', err);
    }, noop);

    _this.pumpStatus = IDLE;
    _this.accountId = null;
    _this.eventId = null;
    _this.componentEventHost = null;
    _this.wsComponentEventHost = null;
    _this.validControlRoomShutdown = false;
    return _this;
  }

  _createClass(EventPumpProducer, [{
    key: 'failoverToHttp',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountId, eventId, componentEventHost) {
        var _this2 = this;

        var unprocessedEvents, eventStatus, promises;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.wsManager.cleanup();
                unprocessedEvents = this.wsManager.getUnprocessedEvents();
                eventStatus = this.eventModel ? this.eventModel.event.status : null;

                console.log('[EventPumpProducer] Failing over to HTTP polling, current pump status: ' + this.pumpStatus + ', current event status: ' + eventStatus);
                this.pumpStatus = HTTP;
                _context2.next = 7;
                return this.httpManager.open(accountId, eventId, componentEventHost, false, eventStatus, this.wsManager.getLastEventProcessed());

              case 7:

                //Post all component events that haven't successfully processed
                //via websocket.
                promises = [].concat(_toConsumableArray(unprocessedEvents)).map(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        key = _ref4[0],
                        _ref4$ = _ref4[1],
                        data = _ref4$.data,
                        metadata = _ref4$.metadata;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            console.log('[EventPumpProducer] Processing component event over HTTP: id: ' + key + ' data: ' + data);
                            return _context.abrupt('return', _this2.httpManager.postEvent(metadata, data, componentEventHost));

                          case 2:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());

                //Process any component events that failed to process via the websocket

                _context2.prev = 8;
                _context2.next = 11;
                return Promise.allSettled(promises).then(function (results) {
                  console.log('[EventPumpProducer] All component events have been posted over HTTP at failover.');
                  results.forEach(function (_ref5) {
                    var status = _ref5.status,
                        _ref5$value = _ref5.value,
                        value = _ref5$value === undefined ? {} : _ref5$value;

                    if (status === 'rejected' || (value.message && value.message.search(/error/i)) !== -1) {
                      console.log('[EventPumpProducer]: CE process status: ' + status + ', CE process message: ' + value.message);
                    }
                  });
                });

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](8);

                console.error('[EventPumpProducer] Problem processing component events over HTTP at failover.', _context2.t0);

              case 16:
                _context2.prev = 16;

                //Empty map of unprocessed component events
                //since they have been posted over HTTP.
                this.wsManager.emptyUnprocessedEvents();
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 13, 16, 19]]);
      }));

      function failoverToHttp(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return failoverToHttp;
    }()

    // This gets called on a STOP_EVENT_STREAM action when we are shutting down the control room

  }, {
    key: 'stop',
    value: function stop() {
      console.log('[EventPumpProducer] Control room is shutting down (or being cleared).');
      _get(EventPumpProducer.prototype.__proto__ || Object.getPrototypeOf(EventPumpProducer.prototype), 'stop', this).call(this);
      this.validControlRoomShutdown = true;
      this.wsManager.cleanup();
    }
  }, {
    key: 'eventModel',


    /**
     * Overrides getEventModel from EventPumpAbstract
     * We add the object wrapper here because the control room and audience apps currently store
     * event details for the current event in different places.
     */
    get: function get() {
      return { 'event': this.store.getState().controlRoom.eventModel };
    }

    /**
     * Use cases where this handler can be called:
     * 1) When a websocket closes unexpectedly and we need to fire the retry protocol
     * 2) When there was a problem with the communication channel when trying to send a message(?)
     */


    /**
     * Starts the event pump for the control room.
     * First makes an attempt to open up a Websocket via the WSEvent class.
     * If that fails, we will use the http polling setup in the super class.
     */

  }], [{
    key: 'instance',
    get: function get() {
      if (!EventPumpProducer[singleton]) {
        console.log('[EventPumpProducer] Creating new instance of EventPumpProducer...');
        EventPumpProducer[singleton] = new EventPumpProducer(singletonEnforcer);
      } else {
        console.log('[EventPumpProducer] Returning singleton instance...');
      }

      return EventPumpProducer[singleton];
    }
  }]);

  return EventPumpProducer;
}(_EventPumpAbstract3.default);

exports.default = EventPumpProducer;